export enum GenderEnum {
    "通用",
    "男性",
    "女性",
}

export enum GenderEnum2 {
    "通用",
    "男",
    "女",
}

export enum GenderEnum3 {
    "通用",
    "男",
    "女",
    "未成年（未满18岁）"
}
